Fastweb.Admin.Articles = (function($) {

  init = function() {
    articleEditorSetup();
    $("select[data-behavior=article-channel]").change(function() {
      var url = window.location.origin;
      $.get({
        url: url + '/admin/articles/article_categories',
        dataType: 'json',
        data: {channel_id: $(this).val()}
      }).done(function(data) {
        var html = '';
        data.forEach(function(element) {
          html = html + '<option value="' + element.id + '">' + element.name + '</option>';
        });
        $('#article_categories').html(html);
      });
    });

    const articleBody = $('#article-editor')
    $('#admin-article-form').on('submit', function() {
      if(articleBody.attr('wrap') == 'on') {
        articleBody.attr('wrap', 'off') 
      }
    })
  }

  function articleEditorSetup() {
    let articleEditor = document.getElementById('article-editor');
    let lineCounter = document.getElementById('line-counter');

    articleEditor.addEventListener('scroll', () => {
      lineCounter.scrollTop = articleEditor.scrollTop;
      lineCounter.scrollLeft = articleEditor.scrollLeft;
    });

    articleEditor.addEventListener('keydown', (e) => {
      let { keyCode } = e;
      let { value, selectionStart, selectionEnd } = articleEditor;
      if (keyCode === 9) { // 9 --> tab
        e.preventDefault();
        articleEditor.value = value.slice(0, selectionStart) + '\t' + value.slice(selectionEnd);
        articleEditor.setSelectionRange(selectionStart+2, selectionStart+2)
      }
    });

    line_counter(articleEditor, lineCounter);
    articleEditor.addEventListener('input', function() {
      var lineCountCache = 0;
      var lineCount = articleEditor.value.split('\n').length;
      var outarr = new Array();
      if (lineCountCache != lineCount) {
        for (var x = 0; x < lineCount; x++) {
          outarr[x] = (x + 1) + ' ';
        }
        lineCounter.value = outarr.join('\n');
      }
      lineCountCache = lineCount;
    });
  }

  function line_counter(articleEditor, lineCounter) {
    var lineCountCache = 0;
    var lineCount = articleEditor.value.split('\n').length;
    var outarr = new Array();
    if (lineCountCache != lineCount) {
      for (var x = 0; x < lineCount; x++) {
        outarr[x] = (x + 1) + ' ';
      }
      lineCounter.value = outarr.join('\n');
    }
    lineCountCache = lineCount;
  }

  initEditFooterRail = function() {
    var addArticle;

    $('.sortable').sortable();

    // Add article to popularity rankings
    $('#add_article').click(function() {
      if(addArticle != undefined) {
        $('.sortable').append('<tr class="ui-sortable-handle">' +
            '<input type="hidden" name="article_ids[]" id="article_id" value="' + addArticle.id + '">' +
            '<td class="hover-grab"></td>' +
            '<td class="hover-grab">' + addArticle.name +
            '</td>' +
            '<td class="hover-grab">' + addArticle.status +
            '</td>' +
            '<td>' +
            '<a target="_blank" href="http://www.fastweb.com/' + addArticle.path + '">View</a>' +
            ' | ' +
            '<a class="remove" href="javascript:void(0);" onclick="$(this).closest(\'tr\').remove();">Remove</a>' +
            ' | ' +
            '<a href="/admin/articles/' + addArticle.slug + '/edit">Edit</a>' +
            '</td>' +
          '</tr>'
        );

        addArticle = undefined;
      }

      $('#search').val('');

    });

    // Remove article from popularity rankings
    $('.remove').click(function() {
      $(this).closest('tr').remove();
    });

    // Article search autocomplete
    $('#search').autocomplete({
      source: function(request, response) {
        url = window.location.origin + '/admin/articles/search';
        text = $('#search').val();
        channel_id = $('#channel_id').val() || '';
        $.ajax({
          url: url,
          dataType: "json",
          data: {q: text, channel_id: channel_id},
          method: 'GET',
          cache: false
        })
        .done(function(data, textStatus, jqXHR) {
          var results = $.map(data, function( item ) {
              return { label: item.name, status: item.status, value: item.id, slug: item.slug, path: item.path };
            });

          response(results);
        })
        .fail(function(jqHXR, textStatus, errorThrown) {
          console.log("Failed to retrieve autocomplete results - " + errorThrown);
        });
      },
      classes: {
        "ui-autocomplete": "white-bg",
      },
      minLength: 2,
      delay: 0,
      select: function(event, ui) {
        addArticle = {id: ui.item.value, name: ui.item.label, status: ui.item.status, slug: ui.item.slug, path: ui.item.path}
        event.preventDefault();
      },
      focus: function(event, ui) {
        event.preventDefault();
        $('#search').val(ui.item.label);
      }
    });
  }

  fetchSlugValFromArticleTitle = function(slug) {
    const slugField = $('#article-slug')
    
    //if the slug is empty - this means the artile/article title hasn't been created yet, allowing us to use the auto-generated slug functionality
    if (slug) {
      $('#article-title').blur(function(){
        var articleTitle = $(this).val();
        articleTitle = articleTitle.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
        slugField.val(articleTitle);
      })
    } else {
      // else the article already exists/user is editing it, we should disabled the slug field
      slugField.prop('disabled', true)
    }
  }

  setCharacterLimit = function(text, charCount) {
    $(text).on('keyup', function() {
      const length = $(this).val().length;
      $(charCount).html(length);
    });
  }

  return {
    init: init,
    initEditFooterRail: initEditFooterRail,
    fetchSlugValFromArticleTitle: fetchSlugValFromArticleTitle,
    setCharacterLimit: setCharacterLimit
  }

})(jQuery);
